import { FaBolt, FaTv, FaHeadset } from "react-icons/fa";

const whyChooseUs = {
  sub: "Why Choose Us",
  heading: "Your Trusted Partner for Connectivity",
  content: "Our commitment to quality sets us apart in delivering reliable connectivity for your home and business.",
  points: [
    {
      id: 1,
      icon: <FaBolt />, // Bolt icon
      title: "High-Speed Internet",
      content: "Enjoy blazing-fast internet speeds that keep you connected for working from home.",
    },
    {
      id: 2,
      icon: <FaTv />, // Tv icon
      title: "Diverse Channel Selection",
      content: "Access a wide range of cable TV channels, including premium content and local programming.",
    },
    {
      id: 3,
      icon: <FaHeadset />, // Headset icon
      title: "24/7 Customer Support",
      content: "Get round-the-clock assistance from our dedicated support team.",
    },
  ],
};

export default whyChooseUs;